export default __webpack_public_path__ + "static/media/react-logo.b8275d56.png";